import LandingTile from './LandingTile';
import { type LandingTilesProps } from './LandingTiles.types';

const LandingTiles: React.FC<LandingTilesProps> = ({
  className,
  title,
  content,
  items,
  size,
}) => (
  <div className={`landing-tiles ${className}`}>
    <div className="landing-tiles__container container">
      <div className="landing-tiles__header">
        {title && <h2 className="h3">{title}</h2>}
        {content && (
          <div
            className="landing-tiles__content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </div>

      <div className="landing-tiles__tiles">
        {items &&
          items.map((item, pos) => (
            <LandingTile key={item.id} size={size} {...item} />
          ))}
      </div>
    </div>
  </div>
);

export default LandingTiles;
